import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';

import Heading from '@react/react-spectrum/Heading';
import Link from '@react/react-spectrum/Link';

import { RootContext } from '../../../root/RootContext';
import { useSidebar } from '../../../views/App';

import { PATHS } from '../../../config/constants';

import './ACCSidebar.scss';

export default function ACCSidebar() {
  let history = useHistory();
  const { hide: closeSidebar } = useSidebar();
  const { state } = useContext(RootContext);

  function handleConfigureClick() {
    history.push(PATHS.ACC_CONFIGURE);
    closeSidebar();
  }

  return (
    <div className="acc-sidebar">
      <section>
        <Heading size={2}>{state.activeACC.url}</Heading>
        <Heading variant="subtitle3">Campaign Classic</Heading>
      </section>

      <section>
        <Heading variant="subtitle1">Actions</Heading>
        <em>ACC Actions coming soon</em>
      </section>

      <section>
        <Heading variant="subtitle1">Properties</Heading>

        <Heading variant="subtitle3">URL</Heading>
        <div>
          <Link href={`https://` + state.activeACC.url} target="_blank">
            https://{state.activeACC.url}
          </Link>
        </div>
      </section>
    </div>
  );
}
